import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

const INITIAL_STATE = Immutable({
  banners: {},
});
export const AdsSelectors = {};

/* ------------- Types and Action Creators ------------- */
export const { Types: AdsActionsType, Creators: AdsActions } = createActions({
  setAds: ['ads'],
});

const setAds = (state, { ads }) => {
  return state.merge({
    banners: ads,
  });
};

const HANDLERS = {
  [AdsActionsType.SET_ADS]: setAds,
};

export default createReducer(INITIAL_STATE, HANDLERS);
